import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime, filter, map} from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild , ViewChildren} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {UserService} from '../../../core/services/users.service';
import {DataSource , SelectionModel} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import {OrganizationsService} from '../../../core/services/organizations.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {FusePerfectScrollbarDirective} from '../../../core/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import {ActivatedRoute , Router} from '@angular/router';
import {FuseConfigService} from '../../../core/services/config.service';
import {AuthService} from '../../../core/services/auth.service';
import {TranslateService} from '@ngx-translate/core';
import {AppConfig} from '../../../app.config';
import {FuseDeleteDialogComponent} from '../../../core/components/delete-dialog/delete-dialog.component';
import {PlatformsService} from '../../../core/services/platforms.service';
import { EventService } from '../../../core/services/event.service';

@Component({
    selector: 'users-page',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class UsersComponent implements OnInit {
  public filterData: any = {};

  users = [];
  pagination: any = {};
  displayedColumns = [ 'select', 'name'  , 'email',   'organization'  , 'activated', 'sendInvite', 'blocked', 'impersonation', 'mainAdmin' ];
  checkedUsers = [];
  countryIdRoute;
  cityIdRoute;
  orgIdRoute;
  normal = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren(FusePerfectScrollbarDirective) scroll;
  selection = new SelectionModel<any>(true, []);
  userFilters;
  defUserFilters;
  role;
  _pageIndex = 0;
  _perPage = 50;
  _sort = 'name';
  _direction = 'asc';
  _search = '';
  userId;

  constructor (private http: HttpClient , private usersService: UserService , private spinner: NgxSpinnerService ,

               private fuseConfig: FuseConfigService ,
               private auth: AuthService,
               private translate: TranslateService,
               private router: Router,
               private appConfig: AppConfig,
               private platformsService: PlatformsService,
               private organizationService: OrganizationsService , public snackBar: MatSnackBar, private route: ActivatedRoute,
               public userService: UserService, public dialog: MatDialog, public eventService: EventService) {
    this.fuseConfig.role.subscribe(res => {
      this.role = res;
      if (this.role === 'organisationAdmin') {
        this.displayedColumns = [ 'select', 'name'  , 'email',   'organization'  , 'activated', 'sendInvite', 'blocked', 'impersonation' ];
      }
      if (this.role === 'subCountryAdmin') {
        this.displayedColumns = [ 'select', 'name'  , 'email',   'organization'  , 'activated', 'sendInvite', 'blocked' ];
      }
      if (this.role === 'countryAdmin') {
        this.displayedColumns = [ 'select', 'name'  , 'email',   'organization'  , 'activated', 'sendInvite', 'blocked', 'impersonation'  ];
      }
      if (this.role === 'superAdmin') {
        this.filterData.recommendator = true;
      }
    });
    this.fuseConfig.userId.subscribe((res: any) => {
      if (res) {
        this.userId = res;
      }
    });
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }


  logSuperUser(event, id) {
    this.normal = false;
    event.stopPropagation();
    this.auth.impersonation({id: id}).pipe(map(
      (res: any) => {
        if (res[ 'error' ]) {

          // this.errMsg = res[ 'error' ];
        } else {
          console.log('Done');
          if (! localStorage.getItem('impersonation')) {
            localStorage.setItem('impersonation', Date.now().toString());
            localStorage.setItem('oldToken', localStorage.getItem('accessToken'));
            this.fuseConfig.setImpersonation( Date.now().toString());
          }
          this.auth.setSession(res);
          this.fuseConfig.setToken(res['accessToken']);
          localStorage.setItem('name', res['lastName'] + ' ' + res['firstName']);
          localStorage.setItem('id', res['id']);
          localStorage.setItem('canRecommend', res['canRecommend']);
          localStorage.setItem('allowCompetency', res['allowCompetency']);
          localStorage.setItem('role', res['role'].name);
          localStorage.setItem('eCall', res['eCall']);
          localStorage.setItem('whatsapp', res['whatsapp']);
          localStorage.setItem('logo', res['logo']);
          localStorage.setItem('lang', res['lang']);
          localStorage.setItem('privacy', res['privacy']);
          localStorage.setItem('organizationId', res['organizationId']);
          localStorage.setItem('userEmail', res['email']);
          this.translate.use(localStorage.getItem('lang'));
          this.fuseConfig.setUserName(res['lastName'] + ' ' + res['firstName']);
          this.fuseConfig.setUserId(res['id']);
          this.fuseConfig.userId_Sig.set(res['id']);
          this.fuseConfig.setCanRecommend(res['canRecommend']);
          this.fuseConfig.setAllowCompetency(res['allowCompetency']);
          this.fuseConfig.setECall(res['eCall']);
          this.fuseConfig.setWhatsApp(res['whatsapp']);
          this.fuseConfig.setRole(res['role'].name);
          this.fuseConfig.role_Sig.set(res['role'].name);
          this.fuseConfig.setUserEmail(res['email']);
          if (res['role'].name === 'organisationAdmin') {
            this.fuseConfig.setOrganizationId(res['organizationId']);
            this.fuseConfig.organizationId_Sig.set(res['organizationId']);
            this.platformsService.getByOrganizationId(res['organizationId']).subscribe(platform => {
              this.fuseConfig.setPlatforms(platform);
            });
          } else {
            this.fuseConfig.setOrganizationId(null);
            this.fuseConfig.organizationId_Sig.set(null);
            this.fuseConfig.setPlatforms(null);
          }
          this.fuseConfig.setLogo(res['logo']);
          this.fuseConfig.setPrivacy(res['privacy']);
          this.appConfig.setAuthToken(res['accessToken']);
          if (res.hasOwnProperty('organizationName')) {
            localStorage.setItem('organizationName', res['organizationName']);
            this.fuseConfig.setOrganizationName(res['organizationName']);
          } else {
            localStorage.setItem('organizationName', '');
            this.fuseConfig.setOrganizationName('');
          }

          if (res.hasOwnProperty('organizationType')) {
            localStorage.setItem('organizationType', res['organizationType']);
            this.fuseConfig.setOrganizationType(res['organizationType']);
          } else {
            localStorage.setItem('organizationType', '');
            this.fuseConfig.setOrganizationType('');
          }

          if (res.hasOwnProperty('country')) {
            localStorage.setItem('country', JSON.stringify(res['country']));
            this.fuseConfig.setCountry(res['country']);
          } else {
            localStorage.setItem('country', '');
            this.fuseConfig.setCountry('');
          }

          if (res.hasOwnProperty('city')) {
            localStorage.setItem('city', JSON.stringify(res['city']));
            this.fuseConfig.setCity(res['city']);
          } else {
            localStorage.setItem('city', '');
            this.fuseConfig.setCity('');
          }
          this.spinner.show();
          setTimeout(() => {
            if (res.openEvent) {
              this.router.navigate(['/']);
            } else {
              this.router.navigate(['/pages/organization']);
            }
            this.spinner.hide();
            this.normal = true;
          }, 3000);
          if (res['role'] === 'superAdmin') {
            this.fuseConfig.setSuperAdmin('true');
            localStorage.setItem('email', res['email']);
            localStorage.setItem('password', res['password']);
          }
        }
      })).subscribe();
  }

  navigateToUserDetail(user) {
    console.log(user);
    if (user.role.name !== this.role) {
      this.router.navigate(['/pages/user/detail'], {queryParams: {id: user.id}} );
    } else {
      let msg = this.translate.instant('no_access_to_edit_user');
      this.snackBar.open(msg,  '', {
        duration: 2000,
      });
    }
  }


  ngOnInit () {
    this.route.queryParams.pipe(filter(params => params.country)).subscribe((params: any) => {
      if (params && params.subCountry) {
        this.cityIdRoute = params.subCountry;
      }
      if (params && params.orgId) {
        this.orgIdRoute = params.orgId;
      }
      if (params && params.country) {
        this.countryIdRoute = params.country;
      }

    });
    this.spinner.show();
    let sortFromLS: any = localStorage.getItem('adminUserSort');
    let sortDirFromLS: any = localStorage.getItem('adminUserSortDirection');
    if (sortFromLS && sortDirFromLS) {
      this._sort = sortFromLS;
      this._direction = sortDirFromLS;
    }
    this._pageIndex = +localStorage.getItem('adminUserPageIndex') ? +localStorage.getItem('adminUserPageIndex') : 0;
    this._search = localStorage.getItem('adminUserSearch') ? localStorage.getItem('adminUserSearch') : '';
    if (this._search && this._search !== null && this._search !== 'null') {
      this.filter.nativeElement.value = this._search;
    }
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          localStorage.setItem('adminUserSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollAdmin();
          this.fetchData();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          localStorage.setItem('adminUserSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollAdmin();
          this.fetchData();
        }
      });
    this.filterData.activated = true;
    this.getCountries();
    this.getRole();
    this.getUserFilters();
  }
  getRole () {
    this.usersService.getRoles().subscribe((res: any) => {
      if (res.length > 1) {
        if (this.countryIdRoute) {
          res.map(el => {
            if (+el.id === +4){
              el.selected = true;
            }
          });
        }
        this.filterData.roles = res;
        if (this.countryIdRoute) {
          this.usersService.setRoles({role: 4, selected: true});
          this.fetchData();
        }
      } else {
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
        if (this.countryIdRoute) {
          this.usersService.setCountryId(this.countryIdRoute);
          this.getCantons(this.countryIdRoute);
          if (!this.cityIdRoute) {
            this.fetchData();
          }
        }
      } else if (res.length === 1) {
        this.getCantons(res[ 0 ].id);
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        if (this.cityIdRoute) {
          res.map(el => {
            if (+el.id === +this.cityIdRoute){
              el.selected = true;
            }
          });
        }
        this.filterData.cantons = res;
        if (this.cityIdRoute) {
          this.usersService.setCities({selected: true , canton: this.cityIdRoute});
          this.getOrganizations();
          if (!this.orgIdRoute) {
            this.fetchData();
          }
        }
      } else if (res.length === 1) {
        this.usersService.setCities({selected: true , canton: res[ 0 ].id});
        this.getOrganizations();
        delete this.filterData.cantons;
      } else {
        delete this.filterData.cantons;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getOrganizations () {
    this.usersService.getOrganizationByCantons().subscribe((res: any) => {
      if (res.length > 1) {
        if (this.orgIdRoute) {
          res.map(el => {
            if (+el.id === +this.orgIdRoute){
              el.selected = true;
            }
          });
        }
        this.filterData.organizations = res;
        if (this.orgIdRoute) {
          this.usersService.setOrganizations({selected: true , organization: this.orgIdRoute});
          this.fetchData();
        }
      } else if (res.length === 1) {
        this.usersService.setOrganizations(res[ 0 ].id);
        this.fetchData();
        delete this.filterData.organizations;
      } else {
        delete this.filterData.organizations;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  chooseFilters (e) {
    console.log(e);
    this.paginator.firstPage();
    this.cleanScrollAdmin();
    if (e.choose === 'all') {
      delete this.filterData.cantons;
      delete this.filterData.countries;
      delete this.filterData.organizations;
      delete this.filterData.roles;
      delete this.filterData.activated;
      delete this.filterData.recommendator;
      this.usersService.setToAll();
      this.fetchData();
      this.getCountries();
      this.getRole();
      setTimeout(() => {
        this.filterData.activated = true;
        if (this.role === 'superAdmin') {
          this.filterData.recommendator = true;
        }
      } , 500);
      this.fuseConfig.setActiveFilter(false);
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.filterData.cantons;
      delete this.filterData.organizations;
      this.getCantons(e.choose.country);
      this.usersService.setCountryId(e.choose.country);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('canton')) {
      delete this.filterData.organizations;
      if (+e.choose.canton === +this.cityIdRoute) {
        this.cityIdRoute = '';
        this.orgIdRoute = '';
      }
      this.usersService.setCities(e.choose);
      this.fetchData();
      this.getOrganizations();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('organization')) {
      this.usersService.setOrganizations(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    else if (e.choose.hasOwnProperty('role')) {
      this.usersService.setRoles(e.choose);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    else if (e.choose.hasOwnProperty('activated')) {
      this.usersService.setActivated(e.choose.activated);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    else if (e.choose.hasOwnProperty('recommendator')) {
      this.usersService.setRecommendator(e.choose.recommendator);
      this.fetchData();
      this.fuseConfig.setActiveFilter(true);
    }
    this.setDataFromFilter(e);
  }

  fetchData () {
    this.spinner.show();
    this.usersService.getUsersNew(this._pageIndex + 1, this._perPage, this._sort,
      this._direction, this._search).subscribe((res: any) => {
      this.users = res.users;
      this.pagination = res.pagination;
      this.spinner.hide();
      setTimeout(() => {
        let table = document.getElementById('adminUserPage');
        if (table && localStorage.getItem('adminUserScroll')) {
          table.scrollTop = +localStorage.getItem('adminUserScroll');
        }
      }, 500);
    }, error => {
      this.spinner.hide();
    });
  }

  getUserFilters() {
    this.userService.getFilter('admin').subscribe((res: any) => {
      if (res) {
        this.defUserFilters = res;
        this.userFilters = { admin: JSON.parse(res.config)};
        const config = JSON.parse(res.config);
        if (Object.keys(config).length) {
          this.fuseConfig.setActiveFilter(true);
        } else {
          this.fuseConfig.setActiveFilter(false);
        }
        if (config.hasOwnProperty('roles')) {
          config.roles.forEach(el => {
            this.usersService.setRoles({role: el, selected: true});
          });
        }
        if (config.hasOwnProperty('activated')) {
          if (config.activated) {
            this.usersService.setActivated(true);
          }
        }

        if (config.hasOwnProperty('recommendator')) {
          if (config.recommendator) {
            this.usersService.setRecommendator(true);
          }
        }

        const countryPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('country')) {
            this.usersService.setCountryId(config.country);
            this.organizationService.getCity(+config.country).subscribe((resCanton: any) => {
              if (resCanton.length > 1) {
                if (this.cityIdRoute) {
                  resCanton.map(el => {
                    if (+el.id === +this.cityIdRoute){
                      el.selected = true;
                    }
                  });
                }
                this.filterData.cantons = resCanton;
                if (this.cityIdRoute) {
                  this.usersService.setCities({selected: true , canton: this.cityIdRoute});
                  this.getOrganizations();
                }
              } else if (resCanton.length === 1) {
                this.usersService.setCities({selected: true , canton: resCanton[ 0 ].id});
                this.getOrganizations();
                delete this.filterData.cantons;
              } else {
                delete this.filterData.cantons;
              }
              this.filterData = JSON.parse(JSON.stringify(this.filterData));
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });

        const cantonsPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('cantons')) {
            config.cantons.forEach(el => {
              this.usersService.setCities({canton: el, selected: true});
            });
            this.usersService.getOrganizationByCantons().subscribe((resOrg: any) => {
              if (resOrg.length > 1) {
                if (this.orgIdRoute) {
                  resOrg.map(el => {
                    if (+el.id === +this.orgIdRoute){
                      el.selected = true;
                    }
                  });
                }
                this.filterData.organizations = resOrg;
                if (this.orgIdRoute) {
                  this.usersService.setOrganizations({selected: true , organization: this.orgIdRoute});
                }
              } else if (resOrg.length === 1) {
                this.usersService.setOrganizations(resOrg[ 0 ].id);
                delete this.filterData.organizations;
              } else {
                delete this.filterData.organizations;
              }
              this.filterData = JSON.parse(JSON.stringify(this.filterData));
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });

        const organizationPromise = new Promise((resolve, reject) => {
          if (config.hasOwnProperty('organizations')) {
            config.organizations.forEach(el => {
              this.usersService.setOrganizations({organization: el, selected: true});
            });
            resolve(true);
          } else {
            resolve(true);
          }
        });

        Promise.all([countryPromise, cantonsPromise, organizationPromise]).then(values => {
          console.log(values);
          this.fetchData();
        });

      } else {
        this.fuseConfig.setActiveFilter(false);
        this.userFilters = { admin: {}};
        this.defUserFilters = '';
        this.fetchData();
      }
    });
  }

  setUserFilters(key, value) {
    this.userFilters.admin[key] = value;
    this.userService.setFilters('admin', this.userFilters.admin, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
      });
  }

  setEmptyUserFilters() {
    this.userService.setFilters('admin', {}, this.defUserFilters ? this.defUserFilters.id : '')
      .subscribe((res: any) => {
        this.defUserFilters = res;
        this.userFilters = { admin: {}};
      });
  }

  setDataFromFilter(e) {
    if (e.choose === 'all') {
      this.userFilters.event = {};
      this.setEmptyUserFilters();
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.userFilters.admin['cantons'];
      delete this.userFilters.admin['organizations'];
      this.setUserFilters('country', e.choose.country);
    } else if (e.choose.hasOwnProperty('canton')) {
      const _cities = this.usersService.getCities();
      this.setUserFilters('cantons', _cities);
    } else if (e.choose.hasOwnProperty('organization')) {
      const _organizations = this.usersService.getOrganizations();
      this.setUserFilters('organizations', _organizations);
    }

    else if (e.choose.hasOwnProperty('role')) {
      const _role = this.usersService.getRolesIds();
      this.setUserFilters('roles', _role);
    }
    else if (e.choose.hasOwnProperty('activated')) {
      this.setUserFilters('activated', e.choose.activated);
    }
    else if (e.choose.hasOwnProperty('recommendator')) {
      this.setUserFilters('recommendator', e.choose.recommendator);
    }
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.users.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.users.forEach(row => this.selection.select(row));
    this.checkedUsers = this.selection.selected;
    console.log(this.checkedUsers);
    if (this.checkedUsers && this.checkedUsers.length && this.pagination && this.pagination.total) {
      if (+this.pagination.total > +this._perPage) {
        const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
          width: '300px' ,
          data: {title: 'Choose_all' , message: 'choose_all_msg'}
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.spinner.show();
            this.usersService.getUsersNew(1, 100000, this._sort,
              this._direction, this._search).subscribe((res: any) => {
                if (res && res.users) {
                  this.checkedUsers = res.users;
                }
              this.spinner.hide();
            }, error => {
              this.spinner.hide();
            });
          }
        });
      }
    }
  }

  checkUser(user, event) {
    if (event.checked) {
      this.checkedUsers.push(user);
    } else {
      let index = this.checkedUsers.findIndex(x => +x.id === +user.id);
      if (index !== -1) {
        this.checkedUsers.splice(index, 1);
      }
    }
    console.log(this.checkedUsers);
  }

  setMainUser(event, userdId) {

  }

  communicationAction(event) {
    let ids = [];
    for (let i = 0; i < this.checkedUsers.length; i++ ) {
      ids.push(this.checkedUsers[i].id);
    }
    this.router.navigate(['/pages/communications'], {queryParams: {
      type: event.value,
      ids: ids.toString(),
      userType: 'admin'
    }});
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    localStorage.setItem('adminUserPageIndex' , e.pageIndex);
    this.cleanScrollAdmin();
    this.fetchData();
  }

  sortData(e) {
    this._sort = e.active;
    this._direction = e.direction;
    if (!e.direction) {
      this._sort = 'name';
      this._direction = 'asc';
    }
    localStorage.setItem('adminUserSort', this._sort);
    localStorage.setItem('adminUserSortDirection', this._direction);
    this.cleanScrollAdmin();
    this.fetchData();
  }

  onScroll(e) {
    localStorage.setItem('adminUserScroll' , e.target.scrollTop);
  }

  cleanScrollAdmin() {
    let table = document.getElementById('adminUserPage');
    if (table) {
      table.scrollTop = 0;
      localStorage.setItem('adminUserScroll' , '0');
    }
  }
}

// export class FilesDataSource extends DataSource<any> {
//   _filterChange = new BehaviorSubject('');
//   _filteredDataChange = new BehaviorSubject('');
//
//   get filteredData (): any {
//     return this._filteredDataChange.value;
//   }
//
//   set filteredData (value: any) {
//     this._filteredDataChange.next(value);
//   }
//
//   get filter (): string {
//     return this._filterChange.value;
//   }
//
//   set filter (filter: string) {
//     this._filterChange.next(filter);
//   }
//
//   constructor (private usersService: UserService ,
//                private _paginator: MatPaginator ,
//                private _sort: MatSort) {
//     super();
//     this.filteredData = this.usersService.users;
//   }
//
//   /** Connect function called by the table to retrieve one stream containing the data to render. */
//   connect (): Observable<any[]> {
//     const displayDataChanges = [
//       this.usersService.onUsersChanged ,
//       this._paginator.page ,
//       this._filterChange ,
//       this._sort.sortChange
//     ];
//
//     return observableMerge(...displayDataChanges).pipe(map(() => {
//       // console.log('Changes');
//       let data = this.usersService.users.slice();
//
//       data = this.filterData(data);
//
//       this.filteredData = [ ...data ];
//
//       data = this.sortData(data);
//
//       // Grab the page's slice of data.
//       const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
//       return data.splice(startIndex , this._paginator.pageSize);
//     }));
//   }
//
//   filterData (data) {
//     if (!this.filter) {
//       return data;
//     }
//     return FuseUtils.filterArrayByString(data , this.filter);
//   }
//
//   sortData (data): any[] {
//     if (!this._sort.active || this._sort.direction === '') {
//       return data;
//     }
//
//     return data.sort((a , b) => {
//       let propertyA: number | string = '';
//       let propertyB: number | string = '';
//       switch (this._sort.active) {
//         case 'email':
//           [ propertyA , propertyB ] = [ a.email , b.email ];
//           break;
//         case 'name':
//           [ propertyA , propertyB ] = [ a.lastName , b.lastName  ];
//           break;
//         case 'sendInvite':
//           [ propertyA , propertyB ] = [ a.sendInvite , b.sendInvite ];
//           break;
//         case 'activated':
//           [ propertyA , propertyB ] = [ a.activated , b.activated ];
//           break;
//         // case 'country':
//         //   [ propertyA , propertyB ] = [ a.country ? a.country.name : null , b.country ? b.country.name : null ];
//         //   break;
//         // case 'canton':
//         //   [ propertyA , propertyB ] = [ a.city ? a.city.name : null , b.city ? b.city.name : null ];
//         //   break;
//         case 'blocked':
//           [ propertyA , propertyB ] = [ a['blocked'] , b['blocked'] ];
//           break;
//         case 'organization':
//           [ propertyA , propertyB ] = [ a.organization ? a.organization.name : null , b.organization ? b.organization.name : null ];
//           break;
//
//       }
//
//       const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
//       const valueB = isNaN(+propertyB) ? propertyB : +propertyB;
//
//       return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
//     });
//   }
//
//   disconnect () {
//   }
// }
